import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class ExperiencesStateModel extends SubentityStateModel {}
